// ─── FORMULA ENGINE ────────────────────────────────────
// Must Talk To = goal × 5  (20% close rate)
// 3 calls + 2 emails + 1 text per prospect (per conversation standard)
// Working days per month = 26
const calcActivityTargets = (goal, workingDays = 26) => {
  const prospectsNeeded = goal * 5;           // Must Talk To monthly
  const callsMonth   = prospectsNeeded * 3;   // 3 calls per prospect
  const emailsMonth  = prospectsNeeded * 2;   // 2 emails per prospect
  const textsMonth   = prospectsNeeded * 1;   // 1 text per prospect
  return {
    dailyCalls:  Math.ceil(callsMonth  / workingDays),
    dailyEmails: Math.ceil(emailsMonth / workingDays),
    dailyTexts:  Math.ceil(textsMonth  / workingDays),
    monthlyProspects: prospectsNeeded,
    monthlyCalls:  callsMonth,
    monthlyEmails: emailsMonth,
    monthlyTexts:  textsMonth,
  };
};

export default calcActivityTargets;
